import { Button, Card, Col, Row } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import { DATABASE_IMG, PERFORMANCE_IMG, VIEWALL_IMG, VIEW_ALL_ACTION } from "../../../../../constants/Constant";
import Spinner from "../../../../../utils/Spinner";


const AllDatasetWidget = (props) => {
    const { widgetData, widgetCount, widgetLoad } = props.widget;
    const { roletoggle } = props;
    return (
        <>
            {widgetLoad ? (
                <div className="justify-content-md-center">
                    <Spinner
                        text="Datasets"
                    />
                </div>
            ) :
                ((!widgetLoad && !roletoggle) ? (<>
                    <div className="datasets__type__header pt-3">
                        <div className="sub__header">
                            {" "}
                            {/* <img src={DATABASE_IMG} alt="Database icon" />{" "} */}
                            <span className="do__bu__tag"> Datasets ({widgetCount})</span>
                        </div>
                        <h2 className="view__spacing">
                            <NavLink to="/databook/viewalldatasets" state={{ actionType: VIEW_ALL_ACTION }}>
                                <Button className="view__all__data">
                                    <img src={VIEWALL_IMG} alt="View All icon" />
                                    <span>View All</span>
                                </Button>
                            </NavLink>
                        </h2>
                    </div>
                    <Row className="gy-3 py-4">

                        {widgetData?.map((d, index) => {
                            return (
                                <Col xs={12} sm={6} md={6} lg={4} xl={2} xxl={2} key={index}>
                                    {" "}
                                    <Link
                                        to={`/databook/datasets/alldatasets/${d.id}`}
                                        className="widg__f"
                                    >
                                        <Card className="shadow-none border rounded-1 text-center h-100">
                                            <Card.Body className="bg-transparent rounded-1">
                                                <div className="main__b">
                                                    {/* <span role="img" className="dataset_img_b">
                                                        <img src={PERFORMANCE_IMG} alt="Datasets" />
                                                    </span>
                                                    <div className="sub__b">
                                                        <span className="data__stan__name">{d.name}</span>
                                                        <h5 className="data__stan__val">{d.schema}</h5>
                                                    </div> */}
                                                    <div>
                                                        <div className="card_label_full"><span className="bd__name text-wrap">{d.name}</span></div>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Link>
                                </Col>
                            );
                        })}
                    </Row>
                </>) : "")}
        </>
    );
}

export default AllDatasetWidget;